<template>
  <el-dialog
    :title="ruleData ? '修改提成规则' : '新增提成规则'"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form
      :model="ruleForm"
      :rules="ruleRules"
      ref="ruleFormRef"
      label-width="160px"
      size="small"
      style="width: 700px"
    >
      <el-form-item label="提成账号:" prop="userId">
        <el-select
          v-model="ruleForm.userId"
          placeholder="请选择提成账号"
          style="width: 100%"
          filterable
          :disabled="!!ruleData"
        >
          <el-option
            v-for="item in allUserList"
            :key="item.id"
            :label="item.userName + '(' + item.account + ')'"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对所有人提成:" prop="isGlobal">
        <el-switch
          v-model="isGlobalFlag"
          active-text="是"
          inactive-text="否"
          @change="handleIsGlobalChange"
        ></el-switch>
        <span style="margin-left:10px">（注：不会对提成账号的订单提成）</span>
      </el-form-item>
      <el-form-item
        v-if="!isGlobalFlag"
        label="被提成人账号:"
        prop="targetUserIds"
        :rules="targetUserIdsRules"
      >
        <el-select
          v-model="ruleForm.targetUserIds"
          placeholder="请选择被提成人账号"
          style="width: 100%"
          multiple
          clearable
          filterable
        >
          <el-option
            v-for="item in filteredTargetUserList"
            :key="item.id"
            :label="item.userName + '(' + item.account + ')'"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提成百分比:" prop="commissionRate">
        <el-input
          v-model="ruleForm.commissionRate"
          placeholder="请输入提成百分比，如1.00表示1%"
          style="width: 100%"
        >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="备注:" prop="remarks">
        <el-input
          type="textarea"
          placeholder="请输入备注（最多500字）"
          maxlength="500"
          v-model="ruleForm.remarks"
          :rows="4"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RuleDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    ruleData: {
      type: Object,
      default: null,
    },
  },
  data() {
    const validateCommissionRate = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入提成百分比"));
        return;
      }
      const num = parseFloat(value);
      if (isNaN(num) || num < 0) {
        callback(new Error("提成百分比必须大于等于0"));
        return;
      }
      // 检查是否为两位小数
      const decimalPart = value.toString().split(".")[1];
      if (decimalPart && decimalPart.length < 2) {
        callback(new Error("提成百分比最小两位小数"));
        return;
      }
      callback();
    };

    const validateTargetUserIds = (rule, value, callback) => {
      if (!this.isGlobalFlag && (!value || value.length === 0)) {
        callback(new Error("当不对所有人提成时，被提成人账号不能为空"));
        return;
      }
      callback();
    };

    return {
      dialogVisible: this.visible,
      ruleForm: {
        userId: null,
        isGlobal: 1,
        targetUserIds: [],
        commissionRate: null,
        remarks: "",
      },
      isGlobalFlag: true,
      ruleRules: {
        userId: [{ required: true, message: "请选择提成账号", trigger: "change" }],
        commissionRate: [{ required: true, validator: validateCommissionRate, trigger: "blur" }],
      },
      targetUserIdsRules: [
        { required: false, validator: validateTargetUserIds, trigger: "change" },
      ],
      allUserList: [],
    };
  },
  computed: {
    // 过滤掉自身的被提成人账号列表
    filteredTargetUserList() {
      if (!this.ruleForm.userId) {
        return this.allUserList;
      }
      // 排除当前选择的提成账号（自身）
      return this.allUserList.filter(user => user.id !== this.ruleForm.userId);
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.initForm();
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
    // 当提成账号改变时，如果被提成人账号中包含自身，则移除
    'ruleForm.userId'(newUserId, oldUserId) {
      if (newUserId && this.ruleForm.targetUserIds && this.ruleForm.targetUserIds.length > 0) {
        // 如果被提成人账号中包含新选择的提成账号（自身），则移除
        this.ruleForm.targetUserIds = this.ruleForm.targetUserIds.filter(id => id !== newUserId);
      }
    },
  },
  created() {
    this.getAllUserList();
  },
  methods: {
    getAllUserList() {
      this.$store.dispatch("setAllUserList").then(() => {
        this.allUserList = this.$store.state.allUserList;
      });
    },
    initForm() {
      if (this.ruleData) {
        // 编辑模式
        let targetUserIds = this.ruleData.targetUserIds
          ? this.ruleData.targetUserIds.split(",").map((id) => parseInt(id))
          : [];
        // 确保被提成人账号中不包含自身
        if (this.ruleData.userId && targetUserIds.includes(this.ruleData.userId)) {
          targetUserIds = targetUserIds.filter(id => id !== this.ruleData.userId);
        }
        this.ruleForm = {
          id: this.ruleData.id,
          userId: this.ruleData.userId,
          isGlobal: this.ruleData.isGlobal,
          targetUserIds: targetUserIds,
          commissionRate: this.ruleData.commissionRate,
          remarks: this.ruleData.remarks || "",
        };
        this.isGlobalFlag = this.ruleData.isGlobal === 1;
      } else {
        // 新增模式
        this.ruleForm = {
          userId: null,
          isGlobal: 1,
          targetUserIds: [],
          commissionRate: null,
          remarks: "",
        };
        this.isGlobalFlag = true;
      }
      this.$nextTick(() => {
        if (this.$refs.ruleFormRef) {
          this.$refs.ruleFormRef.clearValidate();
        }
      });
    },
    handleIsGlobalChange(val) {
      this.ruleForm.isGlobal = val ? 1 : 0;
      if (val) {
        // 当切换为"是"时，清空被提成人账号（因为字段会隐藏）
        this.ruleForm.targetUserIds = [];
      }
      // 重新校验被提成人账号
      this.$nextTick(() => {
        if (this.$refs.ruleFormRef) {
          this.$refs.ruleFormRef.validateField("targetUserIds");
        }
      });
    },
    submit() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            commissionRate: parseFloat(this.ruleForm.commissionRate),
          };
          const url = this.ruleData
            ? "/v1/web/commission-rule/update"
            : "/v1/web/commission-rule/add";
          this.axios({
            url,
            method: "post",
            data,
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(this.ruleData ? "修改成功" : "新增成功");
              this.$emit("success");
              this.closeDialog();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    closeDialog() {
      this.$refs.ruleFormRef.resetFields();
      this.ruleForm = {
        userId: null,
        isGlobal: 1,
        targetUserIds: [],
        commissionRate: null,
        remarks: "",
      };
      this.isGlobalFlag = true;
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
</style>

